module.exports = __webpack_public_path__ + "static/bengalathon-4755ab8dd1492be8d83bbead974e1b7c.jpeg";